import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fs-15px fw-500 text-cool-gray-80 q-mr-sm"
}

import { watchEffect } from 'vue'
import { useBranchesStore } from 'src/stores'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  multiple?: boolean
  rightTitle?: boolean
}

type Emits = { 'update:modelValue': [branchesStore: ReturnType<typeof useBranchesStore>] }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseBranchSelection' },
  __name: 'BaseBranchSelection',
  props: {
    multiple: { type: Boolean, default: true },
    rightTitle: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

// TODO : emit on mounted // Check is branched more than one then show this
// TODO : selection in item entity page




const props = __props

const branchesStore = useBranchesStore()

const { t: globalT } = translate(globalTranslateObject)

watchEffect(() => {
  // multiple is array, array selected_stores
  if (props.multiple && Array.isArray(branchesStore.selected_stores)) {
    branchesStore.selected_stores = branchesStore.stores.filter((store) => {
      if (Array.isArray(branchesStore.selected_store_ids)) return branchesStore.selected_store_ids.includes(store.value as number)
      else return branchesStore.selected_store_ids === store.value
    })
    if (!Array.isArray(branchesStore.selected_store_ids))
      branchesStore.selected_store_ids = [branchesStore.selected_store_ids]
  }
  // multiple is array, object selected_stores
  else if (props.multiple && !Array.isArray(branchesStore.selected_stores)) {
    branchesStore.selected_stores = [branchesStore.selected_stores]
  }
  // multiple is object, array selected_stores
  else if (!props.multiple && Array.isArray(branchesStore.selected_stores)) {
    branchesStore.selected_stores = branchesStore.selected_stores[0]
    if (Array.isArray(branchesStore.selected_store_ids))
      branchesStore.selected_store_ids = branchesStore.selected_store_ids[0]
  }
  // multiple is object, object selected_stores
  else if (!props.multiple && !Array.isArray(branchesStore.selected_stores)) {
    branchesStore.selected_stores =
      branchesStore.stores.find((branch) => branch.value === branchesStore.selected_store_ids) ?? []
  }
})

return (_ctx: any,_cache: any) => {
  const _component_k_dropdown = _resolveComponent("k-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.rightTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(globalT)('select_branch')), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_k_dropdown, {
      modelValue: _unref(branchesStore).selected_store_ids,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_unref(branchesStore).selected_store_ids) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', _unref(branchesStore))))
      ],
      options: _unref(branchesStore).stores,
      for: "radio-dropdown",
      "external-label": !__props.rightTitle && _unref(globalT)('select_branch'),
      icon: "instore",
      "options-mode": __props.multiple ? 'checkbox' : 'label',
      multiple: __props.multiple,
      style: _normalizeStyle(__props.rightTitle && 'width: 380px')
    }, null, 8, ["modelValue", "options", "external-label", "options-mode", "multiple", "style"])
  ], 64))
}
}

})